import React from 'react'

import { describeActiveFilters, type VariantFilters } from './variantQuery'

export type ActiveFilterChipsProps = {
  filters: VariantFilters
  onChange: (next: VariantFilters) => void
  onReset: () => void
}

/**
 * Horizontal bar of removable chips mirroring the active sidebar filters
 * (GEN-3139). Each chip clears just its own constraint; "Clear all" mirrors the
 * sidebar Reset. Renders nothing when no filter is active so it takes no space.
 */
const ActiveFilterChips: React.FC<ActiveFilterChipsProps> = ({ filters, onChange, onReset }) => {
  const chips = describeActiveFilters(filters)
  if (chips.length === 0) return null

  return (
    <div
      className="border-border-subtle flex flex-wrap items-center gap-1.5 border-b px-2 py-1.5"
      data-testid="active-filter-chips"
    >
      {chips.map((chip) => (
        <span
          key={chip.id}
          className="bg-brand-50 text-brand-800 inline-flex items-center gap-1 rounded-full py-0.5 pr-1 pl-2 text-[11px]"
          data-testid="active-filter-chip"
        >
          {chip.label}
          <button
            type="button"
            onClick={() => onChange(chip.next)}
            aria-label={`Remove filter ${chip.label}`}
            title="Remove filter"
            className="hover:bg-brand-200 hover:text-brand-900 flex h-3.5 w-3.5 items-center justify-center rounded-full leading-none"
          >
            x
          </button>
        </span>
      ))}
      <button
        type="button"
        onClick={onReset}
        className="text-brand-700 ml-1 text-[11px] hover:underline"
        data-testid="active-filter-clear-all"
      >
        Clear all
      </button>
    </div>
  )
}

export default ActiveFilterChips
